module.exports = __webpack_public_path__ + "../public/img/ylw_icoFunc.7e259928.png";